import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import ForgotPwd from "./ForgotPwd";
import ForgotUserName from "./ForgotUserName";

const ForgotPassword = () => {
  const [validId, setValidId] = useState("");
  const [forgotUser, setForgotUser] = useState(false);
  const [forgotPwd, setForgotPwd] = useState(false);
  const [forgotMain, setForgotMain] = useState(true);

  const location = useLocation();
  const navigate = useNavigate();

  useEffect(() => {
    const state = location.state;
    if (state?.validId) {
      setValidId(state.validId);
    }
  }, [location.state]);

  const handleUserName = () => {
    setForgotUser(true);
    setForgotPwd(false);
    setForgotMain(false);
  };

  const handlePassword = () => {
    setForgotPwd(true);
    setForgotUser(false);
    setForgotMain(false);
  };

  const handleBackUser = () => {
    setForgotMain(true);
    setForgotUser(false);
  };

  const handlePwdBack = () => {
    setForgotMain(true);
    setForgotPwd(false);
  };

  const handleBackLogin = () => {
    navigate("/login", { state: { validId } });
  };

  const urlData = "";

  return (
    <div className="login-page">
      <div className="login-shell forgot-password-shell">
        <section className="login-hero" aria-label="Username and password recovery overview">
          <div className="login-brand-mark is-image-logo">
            <img alt="WorkFINITY" src="/assets/Img/logo_ft.png" />
          </div>
          <p className="login-kicker">Account Recovery</p>
          <h1>Recover your sign-in details</h1>
          <p className="login-copy">
            Regain access with guided recovery for your username or password using your registered account details.
          </p>
          <div className="login-highlights" aria-label="Recovery options">
            <span>Username</span>
            <span>Password</span>
            <span>Security code</span>
          </div>
        </section>

        <section className="login-panel" aria-label="Forgot username or password">
          <div className="login-card forgot-password-card">
            {forgotMain && (
              <React.Fragment>
                <div className="login-card-header">
                  <button
                    type="button"
                    onClick={handleBackLogin}
                    className="btn btn-link btn-sm login-back"
                  >
                    <i className="fa fa-arrow-left" aria-hidden="true"></i>
                    Go Back
                  </button>
                  <p className="login-step-label">Forgot username / password?</p>
                  <h2>Choose what to recover</h2>
                  <p>
                    Select the account detail you need help with and we will guide you through verification.
                  </p>
                </div>

                <div className="forgot-option-list">
                  <button
                    className="btn forgot-option-button"
                    onClick={handleUserName}
                  >
                    <i className="fa fa-user-o" aria-hidden="true"></i>
                    <span>
                      I Forgot My Username
                      <small>Recover the username linked to your registered email.</small>
                    </span>
                  </button>
                  <button
                    className="btn forgot-option-button"
                    onClick={handlePassword}
                  >
                    <i className="fa fa-lock" aria-hidden="true"></i>
                    <span>
                      I Forgot My Password
                      <small>Verify your identity and continue password recovery.</small>
                    </span>
                  </button>
                </div>

                <div className="login-support">
                  Need help?{" "}
                  <a href="mailto:Support@workfinity.com">
                    Support@workfinity.com
                  </a>
                </div>
              </React.Fragment>
            )}

            {forgotUser && (
              <div className="forgot-password-recovery">
                <ForgotUserName
                  handleBackUser={handleBackUser}
                  forgotType="Username"
                  urlData={urlData}
                ></ForgotUserName>
              </div>
            )}

            {forgotPwd && (
              <div className="forgot-password-recovery">
                <ForgotPwd
                  handlePwdBack={handlePwdBack}
                  forgotType="pwd"
                  urlData={urlData}
                ></ForgotPwd>
              </div>
            )}
          </div>
        </section>
      </div>
    </div>
  );
};

export default ForgotPassword;
